import {
  TComponentKeys,
} from '@/types/openapi-type.ts';

const tooltip: TComponentKeys<'AuditTrailSettings'> = {
  isEnabled: 'Określa, czy ścieżka audytu jest włączona. Jeśli jest wyłączona, żadne zdarzenia nie będą rejestrowane.',
  retentionPeriodDays: 'Określa, jak długo zdarzenia są przechowywane. Stare zdarzenia są usuwane co godzinę. Maksymalny okres to 31 dni.',
};

export default {
  tooltip,
};
